import { ref } from 'vue';

// Singleton — refs a nivel de módulo compartidos por toda la app
const mensaje = ref(null);
const tipo = ref('error');

export function useToast() {
  function error(texto) {
    mensaje.value = texto;
    tipo.value = 'error';
  }
  function success(texto) {
    mensaje.value = texto;
    tipo.value = 'success';
  }
  function cerrar() {
    mensaje.value = null;
  }
  return { mensaje, tipo, error, success, cerrar };
}
